import { createContext } from 'react';
import { ProgramCounts } from 'redux/schemas/app/mentoring-programs';

import { MentoringProgramNormalized } from 'redux/schemas/models/mentoring-programs';

export enum MentoringProgramError {
  USER_NOT_AUTHORIZED = 'error.mentorship_program.user_not_authorized',
  USER_DROPPED = 'error.mentorship_program.user_dropped',
}

export type MentoringProgramContextValue = {
  isLoading: boolean;
  mentoringProgram?: MentoringProgramNormalized;
  countState: {
    result: ProgramCounts | null;
    isLoading: boolean;
    refresh: () => Promise<void>;
  };
  error: MentoringProgramError;
  timeZone: {
    ianaTimeZone: string;
    timeZoneAbbreviation: string;
  };
};

const MentoringProgramContext = createContext<MentoringProgramContextValue>(null);

export default MentoringProgramContext;

export type MentoringProgramHomeUIContextValue = {
  withOverflowFlexGrowClass: string;
};

export const MentoringProgramHomeUIContext = createContext<MentoringProgramHomeUIContextValue>(null);
